import React from 'react';
import { PremiumUpsell } from './PremiumUpsell';
import { usePremiumUpsell } from 'partial/OfferManager/modules/PremiumUpsell/hooks/premiumUpsell.hook';
import { useHistory } from 'react-router-dom';
import { PREMIUM_UPSELL } from 'types/morph.pagePosition.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';

const PremiumUpsellController = props => {
  const history = useHistory();

  const premiumUpsell = usePremiumUpsell(
    props.creditInfo,
    history,
    props.eventHandler,
  );
  const atr = getViewModuleTrackingAttributes({
    pagePosition: PREMIUM_UPSELL,
    modulePosition: props.modulePosition,
    vertical: SUBSCRIPTION_VERTICAL,
  });
  useViewModule(atr, true);
  const seenPixel = useSeenModulePixel(atr);

  return (
    <>
      {seenPixel}
      <PremiumUpsell {...premiumUpsell} eventHandler={props.eventHandler} />
    </>
  );
};

export default PremiumUpsellController;
